import React from "react";
import { useTranslation } from "react-i18next";
import { isBefore } from "date-fns";
import { PageLayout } from "@components";
import { RecommendUserForm } from "./components/RecomendUserForm";

export const CashbackDashboardRecommendPage = () => {
  const { t } = useTranslation();
  return (
    <PageLayout
      breadcrumbs={[
        { to: "/", text: t("breadcrumbs.home") },
        { to: "/cashback", text: t("breadcrumbs.cashback") },
        { text: t("domains.cashback.invite.breadcrumbs.page") },
      ]}
      title={t("domains.cashback.invite.title", {
        amount: isBefore(new Date(), new Date("2023-09-29")) ? "50" : "25",
      })}
      data-testid="cashback-dashboard-recommend"
    >
      <RecommendUserForm />
    </PageLayout>
  );
};
